import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=67a46183&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../GbR/10__Projekte/2020-05-28__ROTORBOOKS/03  Website/wordpress/wp-content/themes/wp-kickstart-v3-theme/vue-cli-dev/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports